export type HourReportFormActionSettings = {
  primaryAction: "save" | "submit"
  primaryLabel: string
  showSaveAsDraft: boolean
}

export const makeHourReportFormActionSettings = ({
  supportsSubmission,
  supportsChecking,
  supportsApproval,
  showSaveAsDraft,
  labels,
}: {
  supportsSubmission: boolean
  supportsChecking?: boolean
  supportsApproval?: boolean
  showSaveAsDraft: boolean
  labels?: { saveReport: string; submitForCheck: string; submitForApproval: string }
}): HourReportFormActionSettings => {
  const actionLabels = labels ?? {
    saveReport: "Save report",
    submitForCheck: "Submit for check",
    submitForApproval: "Submit for approval",
  }
  if (!supportsSubmission) {
    return {
      primaryAction: "save",
      primaryLabel: actionLabels.saveReport,
      showSaveAsDraft: false,
    }
  }

  return {
    primaryAction: "submit",
    primaryLabel: supportsChecking
      ? actionLabels.submitForCheck
      : supportsApproval
      ? actionLabels.submitForApproval
      : actionLabels.submitForCheck,
    showSaveAsDraft,
  }
}
